/**
 *  埋点配置文件
 *  https://git.xiaojukeji.com/omega/h5-tracker/tracker-h5/blob/master/README.md
 *  应用组：国际闪送web端
 *  应用名称：闪送B2C
 *  应用标识：omega1a9c792b6c
 */
import env from '@/config/env';

export const appKey = env.isDev || env.isSim ? '110' : 'omega1a9c792b6c';

const omegaConfig = {
  uploadHost: 'omgup.didiglobal.com',
  appKey,
  browserRouterEnable: true,
  autoPosition: false,
  jsErrorFilters: [
    {
      message: /^Script error\.$/,
    },
  ],
};

export default {
  omegaConfig,
};
